import React from 'react';
import Contact from './Contact';
import Experience from './Experience';
import Header from './Header/Header';
import Portfolio from './Portfolio/Portfolio';
import Skills from './Skills';

const Home = () => {
    return (
        <div>
            <Header></Header>
            <Skills></Skills>
            <Experience></Experience>
            <Portfolio></Portfolio>
            <Contact></Contact>
        </div>
    );
}

export default Home;
